import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GET_2FA } from './types'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Col, Grid, Icon, Typography } from 'gu-ui-kit'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import styles from 'modules/User/Security/Security.module.scss'
import formStyles from 'modules/Forms/common-form.module.scss'
import PageHeader from 'components/PageHeader'

const DoubleFA = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(['user'])
  const pathGen = useGeneratePathI18n()
  const { initialized = false, enabled = false } = useSelector((state) => state['user/2fa'])

  useEffect(() => dispatch({ type: GET_2FA }), [])

  return (
    <div className={'layout-tile'}>
      <div className={styles['security__inner']}>
        {initialized ? (
          <>
            <PageHeader
              className={'margin-bottom-40'}
              color={'Label-Primary'}
            >
              {t('security.2fa.heading')}
            </PageHeader>

            <Typography
              component={'div'}
              variant={'Body-20'}
              color={'Label-Fifth'}
              className={'margin-bottom-24'}
            >
              <div className={'margin-bottom-16'}>{t('security.2fa.disabled_description')}</div>
              <div>{t('security.2fa.summary')}</div>
            </Typography>
            <div className={clsx(styles['security__section'], 'margin-bottom-40')}>
              <Grid
                gap={16}
                alignItems={'center'}
              >
                <Col>
                  <Icon
                    className={styles['security__block']}
                    color={enabled ? 'Label-Confirm' : 'Label-Error-Primary'}
                    name={enabled ? 'shield-check' : 'shield-delete'}
                    width={44}
                  />
                </Col>
                <Col>
                  <Grid
                    gap={0}
                    direction={'column'}
                  >
                    <Typography
                      variant={'Body-20'}
                      noMargin
                    >
                      {t('security.2fa.heading')}
                    </Typography>

                    <Typography
                      variant={'Body-20'}
                      color={enabled ? 'Label-Confirm' : 'Label-Error-Primary'}
                      noMargin
                    >
                      {t(enabled ? 'security.2fa.status.enabled' : 'security.2fa.status.disabled')}
                    </Typography>
                  </Grid>
                </Col>
              </Grid>
            </div>

            <div className={formStyles['formControl__action-buttons']}>
              <Button
                component={Link}
                to={pathGen(ROUTES.USER_SETTINGS)}
                variant={'ghost'}
                grey
                size="l"
                color={'Label-Fifth'}
              >
                {t('common::buttons.cancel')}
              </Button>
              <Button
                fullWidth
                component={Link}
                to={pathGen(ROUTES.USER_SECURITY_2FA_SETTING)}
                bgColor={enabled ? 'Label-Error-Primary' : 'Label-GU-Primary'}
                size="l"
                variant="primary"
              >
                {t(enabled ? 'common::buttons.disconnect' : 'common::buttons.connect')}
              </Button>
            </div>
          </>
        ) : (
          <GridSpinner />
        )}
      </div>
    </div>
  )
}

export default DoubleFA
